import { Button } from '@strata/react-buttons';
import { WarningDialog } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';

import { DELETE_USER_ACCOUNT_REASON } from 'components/admin/userAccounts/userAccountHelpers';
import { handleError } from 'services/Error';
import { type OrganizationUser, useDeleteOrganizationUserMutation } from 'store/api/authApi';

interface DeleteUserAccountDialogProps {
    userToDelete?: OrganizationUser;
    onClose: () => void;
}

export const DeleteUserAccountDialog = ({
    userToDelete = undefined,
    onClose,
}: DeleteUserAccountDialogProps) => {
    const [deleteOrganizationUser, { isLoading }] = useDeleteOrganizationUserMutation();
    const displayName = userToDelete?.full_name ?? '';

    return (
        <WarningDialog
            dialogTitle="Remove User"
            isOpen={!!userToDelete}
            primaryButtonLabel="Remove User"
            primaryButtonIntent={Button.Intent.DANGER}
            primaryButtonDisabled={isLoading}
            secondaryButtonLabel="Cancel"
            onPrimaryButtonClick={() => {
                void (async () => {
                    if (!userToDelete) {
                        return;
                    }
                    try {
                        await deleteOrganizationUser({
                            upn: userToDelete.upn,
                            reason: DELETE_USER_ACCOUNT_REASON,
                        }).unwrap();
                        SuccessToast({
                            message: `${displayName}'s user account successfully removed.`,
                        });
                        onClose();
                    } catch (err) {
                        handleError('An error occurred removing the user account.', err as Error);
                    }
                })();
            }}
            onSecondaryButtonClick={onClose}
            width={520}
            dialogContent={
                <>
                    <div className="margin__bottom--large">
                        Are you sure you want to remove the following user account?
                    </div>
                    <div className="margin__bottom--large font-semi-bold">{displayName}</div>
                </>
            }
        />
    );
};
